import React, { useReducer, useState } from 'react';
import { ContentAdDesktop } from 'app/styles/content';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router';
import { useFetchData, useRestoreData } from 'app/hooks/dataHooks';
import styled from 'styled-components';
import { SIZES } from '@fupa/fupa-uikit';
import { ButtonGroup } from 'app/components/button/ButtonGroup';
import { fetchPlayerStatsAlltime, fetchTeamPlayerStats } from 'app/components/team/playerstats/TeamPlayerStatsActions';
import { initialPlayerStatsState, TeamPlayerStatsReducer } from 'app/components/team/playerstats/TeamPlayerStatsReducer';
import PlayerStatsAlltimeGrid from 'app/components/team/playerstats/PlayerStatsAlltimeGrid';
import PlayerStatsSeasonGrid from 'app/components/team/playerstats/PlayerStatsSeasonGrid';
const Container = styled.div.withConfig({
  componentId: "sc-fxq6cl-0"
})(["padding:0 ", " ", ";"], SIZES['4'], SIZES['4']);
const getTitle = (type, team) => {
  var _team$competition;
  if (type === 'alltime') {
    return 'Alltime Spielerstatistik - ';
  }
  return team !== null && team !== void 0 && (_team$competition = team.competition) !== null && _team$competition !== void 0 && (_team$competition = _team$competition.season) !== null && _team$competition !== void 0 && _team$competition.name ? "Spielerstatistik der Saison ".concat(team.competition.season.name, " - ") : "Spielerstatistik der aktuellen Saison - ";
};
const TeamPlayerStatsPage = _ref => {
  let {
    defaultMetaDesc,
    team
  } = _ref;
  const {
    restoredData
  } = useRestoreData('TeamPlayerStatsPage');
  const {
    teamSlug,
    type
  } = useParams();
  const initialState = restoredData !== null && restoredData !== void 0 ? restoredData : initialPlayerStatsState;
  const [state, dispatch] = useReducer(TeamPlayerStatsReducer, initialState);
  const [activeTable, setActiveTable] = useState(type !== null && type !== void 0 ? type : 'season');
  const loadData = (subpage, reload, sortQuery) => {
    const statType = subpage !== null && subpage !== void 0 ? subpage : type;
    if (statType === 'alltime') {
      return fetchPlayerStatsAlltime(teamSlug, reload, sortQuery)(dispatch, state);
    }
    return fetchTeamPlayerStats(teamSlug)(dispatch, state);
  };
  useFetchData(state, loadData, 'TeamPlayerStatsPage');
  const {
    players,
    isFetching,
    error
  } = state.season;
  const title = getTitle(type, team);
  const meta = [{
    name: 'description',
    content: "".concat(title).concat(defaultMetaDesc)
  }];
  const baseUrl = "/team/".concat(teamSlug, "/playerstats");
  const buttons = [{
    url: "".concat(baseUrl),
    label: 'Saison',
    value: 'season'
  }, {
    url: "".concat(baseUrl, "/alltime"),
    label: 'Alltime',
    value: 'alltime'
  }];
  const handleChange = value => {
    loadData(value);
    setActiveTable(value);
  };
  return (
    /*#__PURE__*/
    // @ts-ignore
    React.createElement(ContentAdDesktop, {
      top: "7.125rem",
      noContentPadding: true,
      "data-sentry-element": "ContentAdDesktop",
      "data-sentry-component": "TeamPlayerStatsPage",
      "data-sentry-source-file": "TeamPlayerStatsPage.tsx"
    }, /*#__PURE__*/React.createElement(Helmet, {
      title: title,
      meta: meta,
      "data-sentry-element": "Helmet",
      "data-sentry-source-file": "TeamPlayerStatsPage.tsx"
    }), /*#__PURE__*/React.createElement(ButtonGroup, {
      activeValue: activeTable,
      onChange: handleChange,
      buttons: buttons,
      "data-sentry-element": "ButtonGroup",
      "data-sentry-source-file": "TeamPlayerStatsPage.tsx"
    }), /*#__PURE__*/React.createElement(Container, {
      "data-sentry-element": "Container",
      "data-sentry-source-file": "TeamPlayerStatsPage.tsx"
    }, activeTable === 'season' ? /*#__PURE__*/React.createElement(PlayerStatsSeasonGrid, {
      players: players,
      isLoading: isFetching,
      error: error
    }) : /*#__PURE__*/React.createElement(PlayerStatsAlltimeGrid, {
      data: state.alltime,
      loadData: loadData,
      dispatch: dispatch
    })))
  );
};
export default TeamPlayerStatsPage;